import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import CustomInput from './CustomInput';

const CustomInputGrid = ({ inputs }) => {
  return (
    <>
      {inputs
        .reduce((rows, input, index) => {
          if (index % 2 === 0) {
            rows.push([input]);
          } else {
            rows[rows.length - 1].push(input);
          }
          return rows;
        }, [])
        .map((row, rowIndex) => (
          <Row key={rowIndex}>
            {row.map((inputProps, colIndex) => (
              <Col key={colIndex} md={6}>
                <CustomInput {...inputProps} />
              </Col>
            ))}
          </Row>
        ))}
    </>
  );
};

CustomInputGrid.propTypes = {
  inputs: PropTypes.arrayOf(PropTypes.shape(CustomInput.propTypes)).isRequired,
};

export default CustomInputGrid;
